import { links } from '../brand';
import { PlatformIcon, brandHex } from '../components/PlatformIcon';
import { OutIcon } from './icons';
import { adminLinks } from './data';

/**
 * Links — every URL Bobby manages. Public profiles (what's on the front page)
 * plus the admin/studio back-ends for each platform (shared via ./data).
 */

function Row({ icon, label, url }: { icon: string; label: string; url: string }) {
  return (
    <a className="lrow" href={url} target="_blank" rel="noopener noreferrer">
      <span className="lrow__tile" style={{ background: brandHex(icon) }}>
        <PlatformIcon slug={icon} />
      </span>
      <span className="lrow__label">{label}</span>
      <span className="lrow__out" aria-hidden="true"><OutIcon /></span>
      <span className="sr-only">(opens in a new tab)</span>
    </a>
  );
}

export function LinksPage() {
  return (
    <div className="page-links">
      <header className="ph">
        <h1 className="ph__title">Links</h1>
        <p className="ph__sub">Public profiles and the admin back-ends behind them.</p>
      </header>

      <section className="lgroup">
        <h2 className="lgroup__title">Public profiles</h2>
        <div className="lgroup__list">
          {links.map((l) => (
            <Row key={`pub-${l.icon}`} icon={l.icon} label={l.label} url={l.url} />
          ))}
        </div>
      </section>

      <section className="lgroup">
        <h2 className="lgroup__title">Admin &amp; studio</h2>
        <div className="lgroup__list">
          {adminLinks.map((l) => (
            <Row key={`adm-${l.label}`} icon={l.icon} label={l.label} url={l.url} />
          ))}
        </div>
      </section>
    </div>
  );
}
